function handleMultipleOption({ state, input }) {
  let field = state.get(input.field)
  let selectedOptions = field.value || []
  let add = true
  let newOptions = []
  selectedOptions.forEach(selected => {
    if (selected.key === input.option.key) {
      add = false
    } else {
      newOptions.push(selected)
    }
  })
  if (add) {
    newOptions.push({ ...input.option, selected: true })
  }
  // in multiple we should toggle selected on the options for rendering
  if (field.filteredOptions) {
    state.merge(`${input.field}.filteredOptions.${input.option.filterIndex}`, {
      selected: add
    })
  }
  state.merge(`${input.field}.options.${input.option.index}`, { selected: add })
  state.set(`${input.field}.value`, newOptions)
}
export default handleMultipleOption



// WEBPACK FOOTER //
// ./src/modules/client/actions/handleMultipleOption.js